import { compactChainsHorizontally } from '../utils/autoLayoutUtils';
import { buildPositionChangesFromCustomMap } from './positionChangeBuilders';
import { flushTidyPositionChanges } from './flushTidySaves';

/**
 * After partial interaction auto-layout: compact horizontally then optionally save.
 * @param {{ animateTidy?: boolean }} opts — animateTidy runs rAF + tidy animation callbacks + 350ms end delay.
 */
export function runPartialTidyCompactionAndSave({
  interaction,
  tasks,
  nodeDimensions,
  onPositionChangeBatch,
  onPositionChange,
  onAnimationStart,
  onAnimationEnd,
  skipSave,
  options = {},
  animateTidy = false,
}) {
  const currentPositions = interaction.customPositionsRef.current;
  const compactedPositions = compactChainsHorizontally(
    currentPositions,
    tasks,
    nodeDimensions,
  );

  const saveFromRef = () => {
    if (skipSave) return;
    const finalPositions = interaction.customPositionsRef.current;
    const positionChanges = buildPositionChangesFromCustomMap(tasks, finalPositions);
    flushTidyPositionChanges(
      positionChanges,
      { skipRecordAction: options.skipRecordAction },
      onPositionChangeBatch,
      onPositionChange,
    );
  };

  if (!animateTidy) {
    if (interaction.setCustomPositions) {
      interaction.setCustomPositions(compactedPositions);
    }
    if (!skipSave) {
      setTimeout(saveFromRef, 50);
    }
    return;
  }

  onAnimationStart?.();
  requestAnimationFrame(() => {
    if (interaction.setCustomPositions) {
      interaction.setCustomPositions(compactedPositions);
    }
    setTimeout(() => {
      saveFromRef();
      setTimeout(() => {
        onAnimationEnd?.();
      }, 350);
    }, 50);
  });
}
